import React, { useState, useEffect } from "react";
import "./intro.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Intro({ updateHeader }) {
    const location = useLocation();
    const navigate = useNavigate();
    //const [themeData, setThemeData] = useState(null);
    const [riddlerusLogo, SetriddlerusLogo] = useState("./img/logo.png");
    const [introcontent, Setintrocontent] = useState(null);
    const [textcolor, Setcolorcode] = useState(null);
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    const [themeData, setThemeData] = useState(() => JSON.parse(sessionStorage.getItem('themeData')));
    const [rules, setRules] = useState(["", "", ""]);
    console.log(storedUserData.organizationId);

    useEffect(() => {
        updateHeader({
            backButtonRedirect: "/index?save=true"
        });
    }, []);  // <-- Add an empty dependency array


    useEffect(() => {

        if (themeData != null) {
            const body = document.body;

            if (body.classList.contains('common-bg')) {
                // Check if it's a mobile device (or you can define your own breakpoint)
                if (window.innerWidth <= 768) {
                    // Apply mobile background
                    console.log(themeData.background_mob);
                    body.style.backgroundImage = `url(${themeData.background_mob})`;
                } else {
                    // Apply desktop background
                    console.log(themeData.background_desk);
                    body.style.backgroundImage = `url(${themeData.background_desk})`;
                }
            }


        }
    }, [themeData]);

    useEffect(() => {
        const storedTheme = JSON.parse(sessionStorage.getItem('themeData'));
        setThemeData(storedTheme);

        SetriddlerusLogo(themeData.logo);
        Setintrocontent(themeData.landing_page_title);
        Setcolorcode(themeData.landing_page_title_color);
        setRules(themeData.rules); // ✅ Set rules correctly
    }, []);

    const handleClick = () => {
        if (storedUserData?.organizationId === "demobypass") {
            navigate("/demo");
        } else {
            navigate("/character");
        }
    };

    return (
        <>
            {
                <div className="login-main-container1" style={{ textAlign: "center" }}>
                    <img src={riddlerusLogo} className="login-logo1" />
                </div>
            }
            
            <div className="text-main-container" style={{ color: textcolor,textAlign: "center" }}>
                <h4 id="introtext1">{introcontent}</h4>
            </div>

            <div>
                <ul className="rules" style={{color: textcolor,textAlign: "left"}}>
                    {rules.map((rule, index) => (
                        <li key={index}>{rule || "N/A"}</li> // Show "N/A" if rule is empty
                    ))}
                </ul>
            </div>
            {
                <div style={{ textAlign: "center" }}>
                   
                        <img src="/img/next.png" onClick={handleClick} className="begin-play-img" />
                  
                </div>
            }
        </>
    );
}
export default Intro;